/**
 * Number System Tokens
 * 
 * Foundational numerical values for spacing, sizing, and dimensional properties.
 * These tokens serve as the base for all spacing and sizing throughout the design system.
 * 
 * Based on Figma variable collection: Number System
 */

export const spacing = {
  '0px': '0',
  '2px': '2',
  '4px': '4',
  '8px': '8',
  '10px': '10',
  '12px': '12',
  '16px': '16',
  '20px': '20',
  '24px': '24',
  '32px': '32',
  '40px': '40',
  '48px': '48',
  '56px': '56',
  '66px': '66',
  '80px': '80',
  '128px': '128',
  '160px': '160',
} as const;

export const spacingSemantic = {
  'Spacing/0px': '0',
  'Spacing/4px': '4',
  'Spacing/8px': '8',
  'Spacing/16px': '16',
} as const;

// Combined spacing tokens (both direct and semantic)
export const spacingTokens = {
  ...spacing,
  ...spacingSemantic,
} as const;

// Type exports for TypeScript support
export type SpacingToken = keyof typeof spacing;
export type SpacingSemanticToken = keyof typeof spacingSemantic;
export type SpacingValue = typeof spacing[keyof typeof spacing];

// Helper function to get spacing value as pixels
export const getSpacing = (token: SpacingToken | SpacingSemanticToken): string => {
  const value = spacingTokens[token as keyof typeof spacingTokens];
  return `${value}px`;
};

// Helper function to get spacing value as number
export const getSpacingNumber = (token: SpacingToken | SpacingSemanticToken): number => {
  const value = spacingTokens[token as keyof typeof spacingTokens];
  return Number(value);
};


